import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-crown-whitelist',
  templateUrl: './crown-whitelist.component.html',
  styleUrls: ['./crown-whitelist.component.scss']
})
export class CrownWhitelistComponent implements OnInit {

  @Output() whiteListData: EventEmitter<boolean> = new EventEmitter;
  whiteListUser: any = []
  campaignDetail: any;

  excelFormat: any = {};
  excelArray: any = [];
  excelData: any = [];
  page = 1;
  getPaginationCount;
  deleteWhiteList: any = {}
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    private exportExcelService: ExportExcelService,
    private modalService: NgbModal,
    private toast: ToastClientService

  ) { }

  ngOnInit() {
    // this.whiteListData.emit(true);
    this.campaignDetail = JSON.parse(localStorage.getItem('crown_collection'))

    this.getWhiteListDetail()
  }


  getWhiteListDetail() {
    this.apiService.getHeaders(this.apiConfig.whitelistCrown + `?campaign_id=${this.campaignDetail.campaign_id}&page_no=${this.page}`).subscribe((res: any) => {
      console.log(res)
      this.whiteListUser = res.body.data.data
      this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')
      if (res.body.data.length != 0) {
        if (res.body.data.data.pagination.length != 0) {
          console.log(res.body.data.data.pagination, "pagination data")
          let crown_collection = {
            is_edit: this.campaignDetail.is_edit,
            create: this.campaignDetail.create,
            whitelist: 1,
            points_config: this.campaignDetail.points_config,
            target: this.campaignDetail.target,
            campaign_id: this.campaignDetail.campaign_id
          }
          localStorage.setItem("crown_collection", JSON.stringify(crown_collection))
          this.whiteListData.emit(true);
        }
        this.excelData = res.body.data.data.data;
        for (var k in this.excelData[0]) {
          if (typeof this.excelData[k] !== 'function') {
            console.log("Key is " + k.replace(/_/g, ' '));
            this.excelFormat.header = k.replace(/_/g, ' ');
            this.excelFormat.key = k
            this.excelArray.push(JSON.parse(JSON.stringify(this.excelFormat)));
            console.log(this.excelArray)
          }
        }
      }
    })
  }

  DownloadReportExcel() {
    console.log("here", this.excelData, this.excelArray)
    this.exportExcelService.DownloadReportExcel('Whitelist_outlet', this.excelData, this.excelArray);
  }

  uploadExcel(id) {
    this.router.navigate(["/hubAdmin/crown-upload-excel/" + id])
  }

  paginationClick(e) {
    console.log(e);
    this.page = e;
    this.getWhiteListDetail()
  }


  openDeleteModal(targetModal, data) {
    this.deleteWhiteList = data;
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  deleteRecord() {
    let payload = {
      id: this.deleteWhiteList.id
    }
    this.apiService.post(this.apiConfig.deleteCrownWhitelistOutlet, payload).subscribe((res: any) => {
      console.log(res)
      this.toast.Success(res.body.data)
      this.closeModal()
      this.getWhiteListDetail()
    })
  }

  closeModal() {
    this.modalService.dismissAll()
  }





}
